import {INITIAL_STATE} from './states';

export const credit = (state = INITIAL_STATE, action) => {
    const {type, payload} = action;
    switch (type) {
        case 'SET_CREDIT_DETAILS':
            return {
                ...state,
                details: payload,
            };
        case 'SET_CREDIT_FACTORS':
            return {
                ...state,
                factors: payload,
            };
        case 'SET_CREDIT_CF':
            return {
                ...state,
                criticalFactors: payload,
            };
        default:
            return state;
    }
};
